"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MPShop
 * API documentation
 *
 * The version of the OpenAPI document: 0.0.1-alpha.58
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseDeleteBasketAddOnsToJSON = exports.ResponseDeleteBasketAddOnsFromJSONTyped = exports.ResponseDeleteBasketAddOnsFromJSON = exports.instanceOfResponseDeleteBasketAddOns = void 0;
/**
 * Check if a given object implements the ResponseDeleteBasketAddOns interface.
 */
function instanceOfResponseDeleteBasketAddOns(value) {
    var isInstance = true;
    isInstance = isInstance && "basketItemId" in value;
    return isInstance;
}
exports.instanceOfResponseDeleteBasketAddOns = instanceOfResponseDeleteBasketAddOns;
function ResponseDeleteBasketAddOnsFromJSON(json) {
    return ResponseDeleteBasketAddOnsFromJSONTyped(json, false);
}
exports.ResponseDeleteBasketAddOnsFromJSON = ResponseDeleteBasketAddOnsFromJSON;
function ResponseDeleteBasketAddOnsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'basketItemId': json['basketItemId'],
    };
}
exports.ResponseDeleteBasketAddOnsFromJSONTyped = ResponseDeleteBasketAddOnsFromJSONTyped;
function ResponseDeleteBasketAddOnsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'basketItemId': value.basketItemId,
    };
}
exports.ResponseDeleteBasketAddOnsToJSON = ResponseDeleteBasketAddOnsToJSON;
